import React from "react";

const EmailTriggersIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53.271"
      height="33.909"
      viewBox="0 0 53.271 33.909"
    >
      <g id="db64" transform="translate(-173.612 -235.543)">
        <path
          id="Path_1355"
          data-name="Path 1355"
          d="M439.684,348.57a2.656,2.656,0,0,0,.194,1.022,2.578,2.578,0,0,0,.544.828,2.855,2.855,0,0,0,.854.556l.116.038a3.108,3.108,0,0,0,.88.168h.13a2.788,2.788,0,0,0,1.5-.4,2.542,2.542,0,0,0,.763-.724,1.469,1.469,0,0,0,.142-.246v-2.444a3.061,3.061,0,0,0-.375-.544,1.843,1.843,0,0,0-.219-.22,3.3,3.3,0,0,0-.337-.246,2.972,2.972,0,0,0-.685-.31,2.628,2.628,0,0,0-.789-.1,2.519,2.519,0,0,0-.763.1,1.35,1.35,0,0,0-.323.1,2.888,2.888,0,0,0-.866.569,2.753,2.753,0,0,0-.569.841,1.552,1.552,0,0,0-.091.323,2.018,2.018,0,0,0-.1.685Zm13.023-3.338a9.424,9.424,0,0,1,.376,2.639,7.113,7.113,0,0,1-.142,1.475,7.084,7.084,0,0,1-1.1,2.7,4.946,4.946,0,0,1-.957,1.047,4.619,4.619,0,0,1-1.216.711,3.925,3.925,0,0,1-1.461.271,3.838,3.838,0,0,1-.97-.117,2.9,2.9,0,0,1-.789-.349,3.429,3.429,0,0,1-.918-.866,5.19,5.19,0,0,1-1.268.672,5.674,5.674,0,0,1-3.971-.09,5.084,5.084,0,0,1-1.668-1.1,4.836,4.836,0,0,1-.893-1.216c-.077-.143-.142-.285-.207-.427a5.189,5.189,0,0,1-.388-2.018,5.01,5.01,0,0,1,.414-2,5.136,5.136,0,0,1,.53-.943,4.923,4.923,0,0,1,.582-.7,5.3,5.3,0,0,1,1.384-.983c.091-.039.194-.09.285-.129a5.4,5.4,0,0,1,3.608-.2c.091.026.181.065.272.091.207.077.4.155.594.246v-.621h2.535V350.5a1.654,1.654,0,0,0,.142.789,1.025,1.025,0,0,0,.311.349.954.954,0,0,0,.465.1,1.588,1.588,0,0,0,1.061-.349,2.888,2.888,0,0,0,.724-.9,4.445,4.445,0,0,0,.389-1.125,7.9,7.9,0,0,0,.116-1.488,6.942,6.942,0,0,0-.285-1.94,7.408,7.408,0,0,0-.815-1.785,7.328,7.328,0,0,0-1.254-1.526,7.933,7.933,0,0,0-1.63-1.2,8.068,8.068,0,0,0-1.953-.776c-.13-.039-.272-.064-.4-.091a8.353,8.353,0,0,0-3.919.091,8.082,8.082,0,0,0-1.94.815l-.116.077a7.489,7.489,0,0,0-1.513,1.189,4.255,4.255,0,0,0-.465.5,7.621,7.621,0,0,0-.8,1.125,8.733,8.733,0,0,0-.8,1.927,7.794,7.794,0,0,0-.284,2.134,7.944,7.944,0,0,0,.284,2.16c.039.154.091.3.129.44a9.387,9.387,0,0,0,.672,1.5,8.324,8.324,0,0,0,2.9,2.9,8.084,8.084,0,0,0,1.94.815,8.068,8.068,0,0,0,6.338-.879l.271-.168,1.306,2.172-.271.168a10.5,10.5,0,0,1-5.5,1.539,10.219,10.219,0,0,1-2.819-.389,10.812,10.812,0,0,1-2.548-1.06,11.081,11.081,0,0,1-2.147-1.669,10.64,10.64,0,0,1-1.669-2.147,10.893,10.893,0,0,1-1.074-2.548,1.618,1.618,0,0,1-.052-.233,10.072,10.072,0,0,1-.323-2.6,10.645,10.645,0,0,1,.375-2.807,10.534,10.534,0,0,1,1.074-2.535,9.537,9.537,0,0,1,1.448-1.914,3.048,3.048,0,0,1,.22-.232,9.976,9.976,0,0,1,1.772-1.435c.116-.077.246-.155.376-.232a10.819,10.819,0,0,1,2.548-1.061,11,11,0,0,1,4.592-.232,9.306,9.306,0,0,1,1.086.22,10.918,10.918,0,0,1,2.535,1.022,10.452,10.452,0,0,1,3.815,3.634,10.017,10.017,0,0,1,1.057,2.392Z"
          transform="translate(-226.199 -89.606)"
          fill={fill ? fill : "#7e9bff"}
        />
        <path
          id="Path_1356"
          data-name="Path 1356"
          d="M458.108,257.812v7.4c-.453-.038-.918-.064-1.4-.064a13.321,13.321,0,0,0-7.553,2.327l-1.487-1.978,10.437-7.721c0,.013,0,.026,0,.039Z"
          transform="translate(-240.096 -19.475)"
          fill={fill ? fill : "#7e9bff"}
        />
        <path
          id="Path_1357"
          data-name="Path 1357"
          d="M227.071,235.995l-20.926,15.39L185.4,235.878a2.675,2.675,0,0,1,1.332-.335h38.811a2.785,2.785,0,0,1,1.527.452Z"
          transform="translate(-10.327)"
          fill={fill ? fill : "#7e9bff"}
        />
        <path
          id="Path_1358"
          data-name="Path 1358"
          d="M220.492,332.046l1.565,2.069a13.488,13.488,0,0,0-3.919,9.506,12.99,12.99,0,0,0,.194,2.263H191.407a2.892,2.892,0,0,1-.672-.077L201.2,331.969l9.622,7.229Z"
          transform="translate(-15.001 -84.477)"
          fill={fill ? fill : "#7e9bff"}
        />
        <path
          id="Path_1359"
          data-name="Path 1359"
          d="M184.127,263.684l-10.333,13.658a2.761,2.761,0,0,1-.182-.983V256.081a2.145,2.145,0,0,1,.012-.285Z"
          transform="translate(0 -17.743)"
          fill={fill ? fill : "#7e9bff"}
        />
      </g>
    </svg>
  );
};

export default EmailTriggersIcon;
